import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AIPromptTypes } from '@nu-art/prompting-shared';
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend';
const mandatoryProps_AIPromptType = {
    adapter: SimpleListAdapter([...AIPromptTypes], item => _jsx(_Fragment, { children: item.item })),
    placeholder: 'Select Prompt Type',
};
export const DropDown_AIPromptType = TS_DropDown.prepare(mandatoryProps_AIPromptType);
//# sourceMappingURL=ui-components.js.map